document.addEventListener("DOMContentLoaded", function () {
    const filters = document.querySelectorAll(".filters");
    const elementFiltered = document.querySelectorAll('div[data-target]');

    if (filters.length === 0 || elementFiltered.length === 0) return;

    filters.forEach(filter => {
        filter.addEventListener("click", function () {
            filters.forEach(f => f.setAttribute("aria-pressed", "false"));
            filter.setAttribute("aria-pressed", "true");

            const attribute = filter.getAttribute("data-filter");
            let count = 0;

            elementFiltered.forEach(ef => {
                const show = !attribute || ef.getAttribute("data-target") === attribute;
                ef.classList.toggle("d-none", !show);
                if (show) count++;
            });

            document.getElementById("filter-status").textContent =
                `${count} élément${count > 1 ? "s" : ""} affiché${count > 1 ? "s" : ""}`;
        });
    });
});